export const SET_SELECTED = "PREVIEW_SET_SELECTED"; 

export const SET_INDEX_UPDATE_PREVIEW = "SET_INDEX_UPDATE_PREVIEW";

export const SET_VISIBLE_POPUP = "SET_VISIBLE_POPUP";